<template>
  <div class="home container-fluid">
    <img alt="Vue logo" src="../assets/logo.png">
    <HelloWorld msg="Booknotes"/>
    <div class="col-lg-4 col-md-6 col-sm-12 m-10 bg-danger rounded" v-if="errored">
      <p class="card-text text-white font-weight-bold rounded">Error</p>
    </div>
    <Notes :notes="notes" />
    <div class="botonAgregar float-icon">
       <router-link to="/create">
          <button class="btn btn-success"><i class="bi bi-plus float-icon-icon"></i></button>
       </router-link>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src 
import HelloWorld from '@/components/HelloWorld.vue'
import Notes from '@/components/Notas.vue'

export default {
  name: 'Home',
  components: {
    HelloWorld,
    Notes
  },
  data(){
    return {
      notes: null,
      errored: false
    }
  },
  methods: {
    async getNotes() {
      var datos = new FormData();

      try {
        let response = await fetch('http://cronos8studio.com/cronos/php/getNotes.php', {
          method: 'POST',
          body: datos
        });
        //response
        if(response){
            let jsonResponse = await response.json();
            console.log(jsonResponse)
            this.notes = jsonResponse.value;
        }
      } catch(error) {
        console.log(error);
      }
    }
  },
  mounted(){
    console.log("Montado");
    this.getNotes();
  }
}
</script>

<style scoped>
.float-icon {
  position: fixed;
  bottom: 20px;
  right: 20px;
}
.float-icon button {
  border-radius: 26px;
}
.float-icon-icon {
  font-size: 1.7rem;
}
</style>
